const FighterCategoryIndex = () => import('./views/FighterCategoryIndex.vue')
const FighterCategoryCreate = () => import('./views/FighterCategoryCreate.vue')
const FighterCategoryEdit = () => import('./views/FighterCategoryEdit.vue')

export default [
  {
    path: 'fighters/categories',
    name: 'fighters.categories.index',
    component: FighterCategoryIndex
  },
  {
    path: 'fighters/categories/create',
    name: 'fighters.categories.create',
    component: FighterCategoryCreate
  },
  {
    path: 'fighters/categories/:categoryId(\\d+)',
    name: 'fighters.categories.edit',
    component: FighterCategoryEdit
  }
]
